// MFA (TOTP) helpers on Supabase GoTrue's native factor API for the license
// server admin console. Enforcement is app-side (MfaGate) + backend (aal claim
// check on writes) — a client-only gate in an SPA is bypassable, so the backend
// check is what makes it real.
import { supabase } from './supabase';

export interface AalStatus {
  currentLevel: string | null;
  nextLevel: string | null;
  needsChallenge: boolean; // has a verified factor but this session is aal1
  isAal2: boolean;
  hasFactor: boolean;
}

export async function getAalStatus(): Promise<AalStatus> {
  const { data, error } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
  if (error || !data) {
    return { currentLevel: null, nextLevel: null, needsChallenge: false, isAal2: false, hasFactor: false };
  }
  return {
    currentLevel: data.currentLevel,
    nextLevel: data.nextLevel,
    needsChallenge: data.nextLevel === 'aal2' && data.currentLevel === 'aal1',
    isAal2: data.currentLevel === 'aal2',
    hasFactor: data.nextLevel === 'aal2',
  };
}
